module.exports = __webpack_public_path__ + "img/key 4.5c60ff01.png";